module.exports = __webpack_public_path__ + "images/account-settings-example.png";